import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import './DefaultPage.less';
import { config } from '../../utils/config';
import { Input, Select, DatePicker, message, Descriptions, Badge, Modal, Transfer, Tag } from 'antd';
import moment from 'moment';
import { Crud, Page, Upload } from '../../components';
import * as userActions from '../user/redux/actions';
const { CrudTable, CrudForm, CrudFilter, CrudButtons, CrudDraw } = Crud;
const { SelectFile } = Upload;
const Option = Select.Option;
const statusArrayType = [
  { key: 1, label: '单瓶维护' },
  { key: 2, label: '多瓶维护' },
]
export class Pro_lnglistPage extends Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    value: '',
    isModalVisible: false,
    mockData: [],
    targetKeys: [],
  }
  gettype = () => {
    return statusArrayType.map(item => {
      return <Option key={item.key}>{item.label}</Option>
    });
  }
  state = {
    anquanZzdwBh: '',
    anquanZzdwBhtype: '',
    jiezhiZZdwBh: '',
    jiezhiZZdwBhtype: '',
    tiaoyaZzdwBh: '',
    tiaoyaZzdwBhtype: '',
    jingjiZzdwBh: '',
    jingjiZzdwBhtype: ''
  };
  componentDidMount() {
    const { pro_lnglistPage, currentPro_lnglist } = this.props.product;
    this.fetchList(pro_lnglistPage);
    const { getAllMakeUnitActions, getFrui_qppzList } = this.props.userActions;
    getAllMakeUnitActions();
    // 气瓶品种筛选
    getFrui_qppzList({ page: 1, size: 999 });
  }

  fetchList = (page) => {
    const { getPro_lnglistList } = this.props.actions;
    let params = Object.assign({}, { page: page, orderBy: 'insert_time desc,pid_trace asc' }, { pid: this.pid, noPh: this.noPh, qpCode: this.qpCode });
    getPro_lnglistList(params);
  };

  getDataSource() {
    const { product } = this.props;
    const { pro_lnglistById, pro_lnglistList } = product;
    if (!pro_lnglistList) return [];
    return pro_lnglistList.map(id => pro_lnglistById[id]);
  }

  selectRow = (record) => {
    let self = this
    // console.log(record,'打印')
    const { chooseCurrentPro_lnglist, getProLnglistListAll, getProAssignFaMen } = this.props.actions
    chooseCurrentPro_lnglist(record)
    let params = Object.assign({}, { size: 65535, noPh: record.noPh, orderBy: 'insert_time desc , pid_trace asc', qpCode: this.qpCode });
    // console.log(params,'paramsparamsparamsparamsparams')
    getProLnglistListAll(params)
    // console.log(record.dwAqf)
    if (record.dwAqf) {

      let paramsaq = Object.assign({}, { nameQpfj: '安全阀' });
      getProAssignFaMen(paramsaq).then((ress) => {
        // console.log(ress,'ressressress')
        let arrList = [];
        arrList.push(record.dwAqf);

        const byId = {};
        ress.data.forEach(item => {
          byId[item.zzdwJcname] = item;
        });
        // console.log(byId,'aq')
        // console.log(arrList,'arrListarrListarrList')
        arrList.map(item => byId[item]).map(item =>
          //  console.log(item.zzdwNoLic,'itemitem')
          self.setState({
            anquanZzdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
            anquanZzdwBhtype: item.typeQpfj ? item.typeQpfj : ""
          }, () => {
            // console.log(self.state.anquanZzdwBh,'self.state.anquanZzdwBh')
          }),
        )
      })
    }
    if (record.dwJjf) {
      let paramsjj = Object.assign({}, { nameQpfj: '经济阀' });
      getProAssignFaMen(paramsjj).then((ress) => {
        let arrList = [];
        arrList.push(record.dwJjf);
        const byId = {};
        ress.data.forEach(item => {
          byId[item.zzdwJcname] = item;
        });
        // console.log(byId,'jj')
        arrList.map(item => byId[item]).map(item =>
          self.setState({
            jingjiZzdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
            jingjiZzdwBhtype: item.typeQpfj ? item.typeQpfj : ""
          }),
        )
      })

    }

    if (record.dwJzf) {

      let paramjz = Object.assign({}, { nameQpfj: '截止阀' });
      getProAssignFaMen(paramjz).then((ress) => {
        let arrList = [];
        arrList.push(record.dwJzf);
        const byId = {};
        ress.data.forEach(item => {
          byId[item.zzdwJcname] = item;
        });
        // console.log(byId,'jz')
        arrList.map(item => byId[item]).map(item =>
          self.setState({
            jiezhiZZdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
            jiezhiZZdwBhtype: item.typeQpfj ? item.typeQpfj : ""
          }),
        )
      })
    }

    if (record.dwTyf) {
      let paramsty = Object.assign({}, { nameQpfj: '调压阀' });
      getProAssignFaMen(paramsty).then((ress) => {
        let arrList = [];
        arrList.push(record.dwTyf);
        const byId = {};
        ress.data.forEach(item => {
          byId[item.zzdwJcname] = item;
        });
        // console.log(byId,'ty')
        arrList.map(item => byId[item]).map(item =>
          self.setState({
            tiaoyaZzdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
            tiaoyaZzdwBhtype: item.typeQpfj ? item.typeQpfj : ""
          }),
        )
      })
    }
  }


  expandedRowRender = record => {
    // console.log('expandedRowRender', record)
    return <Descriptions>
      <Descriptions.Item label="公称容积">{record.rj}</Descriptions.Item>
      <Descriptions.Item label="内胆设计壁厚">{record.hdNd}</Descriptions.Item>
      <Descriptions.Item label="内封头设计厚度">{record.hdMyNd}</Descriptions.Item>
      <Descriptions.Item label="重量">{record.zl}</Descriptions.Item>
      <Descriptions.Item label="内胆筒体设计厚度">{record.hdSjNd}</Descriptions.Item>
      <Descriptions.Item label="内胆直径">{record.zjNd}</Descriptions.Item>
      <Descriptions.Item label="内胆气压试验压力">{record.syylNd}</Descriptions.Item>
      <Descriptions.Item label="二维码">{`https://image.zhelut.com/2022/furui?type=lng&qpId=${record.pidTrace}`}</Descriptions.Item>

    </Descriptions>
  }


  // 产品使用手册上传
  get modalMediumSafety() {
    const { actions, product } = this.props;
    const { mediumSafetyUploadingChoose, mediumSafetyUploadingAction } = actions;
    const {
      mediumSafetyUploadingVisible,
      mediumSafetyUploadingId,
      mediumSafetyUploadingActionPending,
      pro_lnglistPage
    } = product;
    let editItem = undefined;
    return {
      visible: mediumSafetyUploadingVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: mediumSafetyUploadingActionPending,
      title: '产品使用手册',
      centered: true,
      elements: [
        {
          key: 'file',
          label: '上传文件',
          initialValue: editItem === undefined ? [] : editItem.mediumsheetOssname,
          widget: SelectFile,
          widgetProps: {},
        }, {

          key: 'ids',
          label: '选择修改编号',
          widget: Select,
          widgetProps: {
            mode: "tags"
          },
          children: this.getAllProducts()
        }
      ],
      onOk: data => {
        let params = new FormData();
        params.append('file', data.file);
        params.append("ids", data.ids);
        mediumSafetyUploadingAction(params).then(res => {
          mediumSafetyUploadingChoose(false);
          this.fetchList(pro_lnglistPage);
        });
      },
      onCancel() {
        mediumSafetyUploadingChoose(false);
      },
    };
  }


  // 产品数据表上传
  // get modalQpDataFile() {
  //   const { product, actions } = this.props;
  //   const { qpDataFileUploadingAction, qpdataFileUploadingChoose } = actions;
  //   const {
  //     qpDataFileUploadingVisible,
  //     qpDataFileUploadingId,
  //     qpDataFileUploadingActionPending,
  //     currentPlan_lng,
  //     pro_lnglistPage
  //   } = product;
  //   let editItem = currentPlan_lng === undefined ? {} : currentPlan_lng;

  //   return {
  //     visible: qpDataFileUploadingVisible,
  //     destroyOnClose: true,
  //     maskClosable: false,
  //     confirmLoading: qpDataFileUploadingActionPending,
  //     title: '产品数据表',
  //     centered: true,
  //     elements: [
  //       {
  //         key: 'file',
  //         label: '上传文件',
  //         initialValue: editItem === undefined ? [] : editItem.qpf,
  //         widget: SelectFile,
  //         widgetProps: {},
  //       }
  //     ],
  //     onOk: data => {
  //       let params = new FormData();
  //       params.append('file', data.file);
  //       qpDataFileUploadingAction(params, qpDataFileUploadingId, false).then(res => {
  //         qpdataFileUploadingChoose(false);
  //         this.fetchList(pro_lnglistPage);
  //       });
  //     },
  //     onCancel() {
  //       qpdataFileUploadingChoose(false);
  //     },
  //   };
  // }

  get listProps() {
    const { product, actions } = this.props;
    const {
      getPro_lnglistListPending,
      pro_lnglistTotal,
      pro_lnglistPage,
      pro_lnglistById,
      pro_lnglistList,
      dianziGenerateActionsError
    } = product;
    const {
      chooseCurrentPro_lnglist,
      deletePro_lnglist,
      dianziGenerateActions,
      productHgzGenerateActions,
      remarkModalChange,
      mediumSafetyUploadingChoose,
      qpdataFileUploadingChoose,
      qualityProveModalChange
    } = actions;
    let a = pro_lnglistList.map(id => pro_lnglistById[id]);
    // 电子识别预览
    const qpflagOssnameYL = (record) => {
      // console.log(record)
      if (record.qpflagOssname) {
        window.open(`${config.attachUrl}${record.qpflagOssname}`);
      } else {
        message.info('请先生成相关证件');
      }
    }
    // 电子识别生成
    const qpflagOssnameSC = (record) => {
      dianziGenerateActions(record.id)
        .then(res => {
          this.fetchList(pro_lnglistPage);
          if (res.status === 400) {
          } else {
            message.success('生成完成');
          }
        })
        .catch(res => {
          console.log(dianziGenerateActionsError, 'dianziGenerateActionsError')
          message.error('参数填写不完整，请检查参数');
        });
    }
    // 产品合格证预览
    const qphgzOssnameYL = (record) => {
      if (record.qphgzOssname) {
        window.open(`${config.attachUrl}${record.qphgzOssname}`);
      } else {
        message.info('请先生成合格证');
      }
    }
    // 产品合格证生成
    const qphgzOssnameSC = (record) => {
      productHgzGenerateActions(record.id)
        .then(res => {
          if (res.status === 400) {
          } else {
            message.success('生成完成');
          }
          this.fetchList(pro_lnglistPage);
          // console.log(res);
        })
        .catch(res => {
          message.error('产品合格证生成失败');
        });
    }
    // 钢印截图预览
    const gypicOssnameYL = (record) => {
      if (record.gypicOssname) {
        window.open(`${config.attachUrl}${record.gypicOssname}`);
      } else {
        message.info('请先生成钢印截图');
      }
    }
    // 产品使用手册预览
    const mediumsheetOssnameYL = (record) => {
      if (record.mediumsheetOssname) {
        // window.open(`https://furuiapi.zhelut.com${record.mediumsheetOssname}`);
        window.open(`${config.attachUrl}${record.mediumsheetOssname}`);
      } else {
        message.error('请上传产品使用手册');
      }
    }
    // 产品数据表预览
    const qpdataFileYL = record => {
      if (record.qpDataFile) {
        window.open(`${config.attachUrl}${record.qpDataFile}`);
      } else {
        message.error('请生成产品数据表');
      }
    }

    // 产品使用手册上传
    const mediumsheetOssnameSC = (record) => {
      const { mediumSafetyUploadingChoose, chooseCurrentPro_lnglist, getProLnglistListAll } = this.props.actions;
      chooseCurrentPro_lnglist(record);
      let params = Object.assign({}, { size: 99999, noPh: record.noPh, orderBy: 'pid' });
      getProLnglistListAll(params).then(res => {
        mediumSafetyUploadingChoose(true, record.id);
      });
    }

    // 气瓶参数文件
    const qpParamsFileYL = record => {
      if (record.qpParamFile) {
        window.open(`${config.attachUrl}${record.qpParamFile}`);
      } else {
        message.error('请上传气瓶附件文件');
      }
    }

    const qpParamsFile = (record) => {
      const { qpParamsFileUploadChoose, chooseCurrentPro_lnglist, getProLnglistListAll } = this.props.actions;
      chooseCurrentPro_lnglist(record);
      let params = Object.assign({}, { size: 99999, noPh: record.noPh, orderBy: 'pid' });
      getProLnglistListAll(params).then(res => {
        qpParamsFileUploadChoose(true, record.id);
      });
    }

    //质量证明编辑
    const zlzmsOssnameBJ = (record) => {
      const { chooseCurrentPro_lnglist, getProLnglistListAll } = this.props.actions;
      chooseCurrentPro_lnglist(record);
      let params = Object.assign({}, { size: 99999, noPh: record.noPh, orderBy: 'pid' });
      getProLnglistListAll(params).then(res => {
        qualityProveModalChange(true);
      });

    }
    // 质量证明预览
    const zlzmsOssnameYL = (record) => {
      if (record.zlzmsOssname) {
        window.open(`${config.attachUrl}${record.zlzmsOssname}`)
      } else {
        message.error('请上传质量证明文件');
      }
    }


    return {
      dataSource: this.getDataSource(),
      loading: getPro_lnglistListPending,
      scroll: { x: 1200 },
      expandedRowRender: (record) => this.expandedRowRender(record),
      rowSelection: {
        onSelect: this.selectRow,
        "type": "radio"
      },
      columns: [
        {
          title: '批号',
          dataIndex: 'noPh',
          key: 'noPh',
          width: 180,
        },
        {
          title: '气瓶编号',
          dataIndex: 'pid',
          key: 'pid',
          width: 180,
        },
        {
          title: '气瓶唯一追溯编号',
          dataIndex: 'pidTrace',
          key: 'pidTrace',
          width: 180,
        },
        {
          title: '填充介质代码',
          dataIndex: 'fillingmediumcode',
          key: 'fillingmediumcode',
          width: 100,
          render: txt => {
            if (txt) {
              txt = txt.replace(/\s*/g, "");
            } else {
              txt = '';
            }
             
            if (txt == 'LNG') {
              return <Tag color="#BC8F8F">{txt}</Tag>
            } else if (txt == 'LAr') {
              return <Tag color='#FFA500'>{txt}</Tag>
            } else if (txt == 'LN2') {
              return <Tag color='#000000'>{txt}</Tag>
            } else if (txt == 'LO2') {
              return <Tag color='#6495ED'>{txt}</Tag>
            } else if (txt == 'LCO2') {
              return <Tag color='#808080'>{txt}</Tag>
            }
          }
        }, {
          title: '最大充装量',
          dataIndex: 'czlMax',
          key: 'czlMax',
          width: 100
        },
        {
          title: '制造日期',
          dataIndex: 'pdate',
          key: 'pdate',
          width: 180,
          render: text => {
            if (text != undefined) {
              return <div>{moment(text).format('YYYY-MM-DD')}</div>;
            } else {
              return <div></div>;
            }
          },
        },
        {
          title: '电子识别',
          dataIndex: 'qpflagOssname',
          key: 'qpflagOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => qpflagOssnameYL(record)}>预览 &nbsp; &nbsp; &nbsp; </a>
              <a onClick={() => qpflagOssnameSC(record)}>生成</a>
            </div>

          }
        },
        {
          title: '产品合格证',
          dataIndex: 'qphgzOssname',
          key: 'qphgzOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => qphgzOssnameYL(record)}>预览 &nbsp; &nbsp; &nbsp;</a>

              <a onClick={() => qphgzOssnameSC(record)}>生成</a>
            </div>
          }
        },
        {
          title: '钢印截图',
          dataIndex: 'gypicOssname',
          key: 'gypicOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => gypicOssnameYL(record)}>预览</a>
            </div>
          }
        }, {
          title: '产品使用手册',
          dataIndex: 'mediumsheetOssname',
          key: 'mediumsheetOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => mediumsheetOssnameYL(record)}>预览 &nbsp; &nbsp; &nbsp; </a>
              <a onClick={() => mediumsheetOssnameSC(record)}>上传</a>
            </div>
          }
        }, {
          title: '质量证明',
          dataIndex: 'zlzmsOssname',
          key: 'zlzmsOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => zlzmsOssnameYL(record)}>预览 &nbsp; &nbsp; &nbsp; </a>
              <a onClick={() => zlzmsOssnameBJ(record)}>编辑</a>
            </div>
          }
        }, {
          title: '气瓶附件文件',
          dataIndex: 'qpParamFile',
          key: 'qpParamFile',
          width: 180,
          render: (txt, record) => {
            return <div>
              <a onClick={() => qpParamsFileYL(record)}>预览 &nbsp; &nbsp; &nbsp;</a>
              <a onClick={() => qpParamsFile(record)}>上传</a>
            </div>
          }
        },
         {
          title: '产品数据表',
          dataIndex: 'qpDataFile',
          key: 'qpDataFile',
          width: 180,
          render: (txt, record) => {
            return <div>
              <a onClick={() => qpdataFileYL(record)}>预览 &nbsp; &nbsp; &nbsp; </a>
            </div>
          }
        }
      ],
      pagination: {
        total: pro_lnglistTotal,
        current: pro_lnglistPage,
        onChange: page => {
          this.fetchList(page);
        },
      },
      op: [
        {
          key: 3,
          name: '删除',
          buttonProps: {
            icon: 'delete',
            type: 'danger',
          },
          needConfirm: true,
          confirmTitle: '确认删除',
        },
      ],
      handleMenuClick: (record, item) => {
        if (item.key === 1) {
          // 编辑备注
          chooseCurrentPro_lnglist(record);
          remarkModalChange(true, 'edit');
        } else if (item.key === 3) {
          deletePro_lnglist(record.id).then(data => {
            this.fetchList(pro_lnglistPage);
          });
        } else if (item.key === 6) {
          message.info('待开发')
        }
      },
    };
  }

  getAllProducts = () => {
    const { pro_lnglistByIdAll, pro_lnglistListAll } = this.props.product
    return pro_lnglistListAll.map(id => pro_lnglistByIdAll[id]).map(item => <Option key={item.id}>{item.pid}</Option>);
  }

  // 安全
  getHandleAnQuan = () => {
    const { getAllMakeUnitList, getAllMakeUnitId } = this.props.user;
    return getAllMakeUnitList
      .map(id => getAllMakeUnitId[id])
      .map(item => <Option key={item.nameJc}>{item.nameJc}</Option>);
  };
  onChangAnQuan = res => {
    let self = this
    console.log(res, 'resresresres')
    const { getProAssignFaMen } = this.props.actions
    const { currentPro_lnglist } = this.props.product
    let params = Object.assign({}, { nameQpfj: '安全阀' });
    getProAssignFaMen(params).then((ress) => {
      let arrList = [];
      console.log(currentPro_lnglist.dwAqf, res, 'currentPro_lnglist.dwAqf,rescurrentPro_lnglist.dwAqf,res')
      arrList.push(res);
      const byId = {};
      ress.data.forEach(item => {
        byId[item.zzdwJcname] = item;
      });
      console.log(byId, 'byIdbyIdbyIdbyId')
      arrList.map(item => byId[item]).map(item =>
        //  console.log(item,'itemitemitemitemitem')
        self.setState({
          anquanZzdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
          anquanZzdwBhtype: !item.typeQpfj ? '' : item.typeQpfj
        }, () => {
          console.log(self.state.anquanZzdwBh, 'self.state.zzdwNoLicself.state.zzdwNoLic')
        }),
      )
    })
  };

  // 截止
  getHandleJieZhi = () => {
    const { getAllMakeUnitList, getAllMakeUnitId } = this.props.user;
    return getAllMakeUnitList
      .map(id => getAllMakeUnitId[id])
      .map(item => <Option key={item.nameJc}>{item.nameJc}</Option>);
  };
  onChangJieZhi = res => {
    let self = this
    const { getProAssignFaMen } = this.props.actions
    let params = Object.assign({}, { nameQpfj: '截止阀' });
    const { currentPro_lnglist } = this.props.product
    getProAssignFaMen(params).then((ress) => {
      let arrList = [];
      arrList.push(res);
      const byId = {};
      ress.data.forEach(item => {
        byId[item.zzdwJcname] = item;
      });
      arrList.map(item => byId[item]).map(item =>
        self.setState({
          jiezhiZZdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
          jiezhiZZdwBhtype: !item.typeQpfj ? '' : item.typeQpfj
        }),
      )
    })

    console.log(res);
  };

  // 调压
  getHandleTiaoYa = () => {
    const { getAllMakeUnitList, getAllMakeUnitId } = this.props.user;
    return getAllMakeUnitList
      .map(id => getAllMakeUnitId[id])
      .map(item => <Option key={item.nameJc}>{item.nameJc}</Option>);
  };
  onChangTiaoYa = res => {
    let self = this
    const { currentPro_lnglist } = this.props.product
    const { getProAssignFaMen } = this.props.actions
    let params = Object.assign({}, { nameQpfj: '调压阀' });
    getProAssignFaMen(params).then((ress) => {
      let arrList = [];
      arrList.push(res);
      const byId = {};
      ress.data.forEach(item => {
        byId[item.zzdwJcname] = item;
      });
      arrList.map(item => byId[item]).map(item =>
        self.setState({
          tiaoyaZzdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
          tiaoyaZzdwBhtype: !item.typeQpfj ? '' : item.typeQpfj
        }),
      )
    })

    // const { getAllMakeUnitList, getAllMakeUnitId } = this.props.user;
    // let arrList = [];
    // let object = {};
    // arrList.push(res);
    // getAllMakeUnitList.map(id => getAllMakeUnitId[id]).map(item => (object[item.nameJc] = item));
    // return arrList
    //   .map(item => object[item])
    //   .map(item =>
    //     this.setState({
    //       tiaoyaZzdwBh: !item.noLic ? '' : item.noLic,
    //     }),
    // );
  };
  // 经济
  getHandleJingJi = () => {

    const { getAllMakeUnitList, getAllMakeUnitId } = this.props.user;
    return getAllMakeUnitList
      .map(id => getAllMakeUnitId[id])
      .map(item => <Option key={item.nameJc}>{item.nameJc}</Option>);
  };
  onChangJingJi = res => {
    const { currentPro_lnglist } = this.props.product
    let self = this
    const { getProAssignFaMen } = this.props.actions
    let params = Object.assign({}, { nameQpfj: '经济阀' });
    getProAssignFaMen(params).then((ress) => {
      let arrList = [];
      arrList.push(res);
      const byId = {};
      ress.data.forEach(item => {
        byId[item.zzdwJcname] = item;
      });
      arrList.map(item => byId[item]).map(item =>
        self.setState({
          jingjiZzdwBh: item.zzdwNoLic ? item.zzdwNoLic : '',
          jingjiZzdwBhtype: !item.typeQpfj ? '' : item.typeQpfj
        }),
      )
    })
  };

  // 参数维护
  onchangQuantity = (res) => {
    const { setQuantity } = this.props.actions
    setQuantity(res)
    let self = this
    if (res == 2) {
      // console.log(res)
      self.getMock()
      self.setState({
        isModalVisible: true
      })
    }
  }

  get modalProps() {
    let self = this
    const { product, actions } = this.props;
    const {
      currentPro_lnglist,
      pro_lnglistModalVisible,
      pro_lnglistPage,
      pro_lnglistModalType,
      submitPro_lnglistPending,
      quantity,
    } = product;
    const { pro_lnglistModalChange, submitPro_lnglist, chooseCurrentPro_lnglist, submitProAlllnglist, getProAssignFaMen } = actions;
    const editItem = pro_lnglistModalType === 'create' ? {} : currentPro_lnglist;



    let type = ''
    if (editItem.type === 1) {
      type = '单瓶维护'
    }
    if (editItem.type === 2) {
      type = '多瓶维护'
    }
    return {
      item: pro_lnglistModalType === 'create' ? {} : currentPro_lnglist,
      visible: pro_lnglistModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitPro_lnglistPending,
      title: '参数维护',
      centered: true,

      elements: [
        {
          key: 'rj',
          label: '公称容积',
          initialValue: editItem.rj,
          widget: Input,
        },
        {
          key: 'pdate',
          label: '制造日期',
          initialValue: moment(editItem.pdate).format('YYYY-MM-DD'),
          widget: Input,
        },
        {
          key: 'sjrq',
          label: '上检日期',
          initialValue: moment(editItem.sjrq),
          widget: DatePicker,
        },
        {
          key: 'gzyl',
          label: '工作压力',
          initialValue: editItem.gzyl,
          widget: Input,
        },
        {
          key: 'hdNd',
          label: '内胆设计壁厚',
          initialValue: editItem.hdNd,
          widget: Input,
        },
        {
          key: 'hdMyNd',
          label: '内胆名义厚度',
          initialValue: editItem.hdMyNd,
          widget: Input,
        },
        {
          key: 'hdSjNd',
          label: '内胆筒体设计厚度',
          initialValue: editItem.hdSjNd,
          widget: Input,
        },
        {
          key: 'hdSjNft',
          label: '内封头设计厚度',
          initialValue: editItem.hdSjNft,
          widget: Input,
        },
        {
          key: 'zjNd',
          label: '内胆直径',
          initialValue: editItem.zjNd,
          widget: Input,
        },
        {
          key: 'typeTs',
          label: '探伤类型',
          initialValue: editItem.typeTs,
          widget: Input,
        },

        {
          key: 'syylGl',
          label: '管路气密性试验压力',
          initialValue: editItem.syylGl,
          widget: Input,
        },
        {
          key: 'sjrj',
          label: '实际容积',
          initialValue: editItem.sjrj,
          widget: Input,
        },
        {
          key: 'syylNd',
          label: '内胆气压试验压力',
          initialValue: editItem.syylNd,
          widget: Input,
        },
        {
          key: 'zl',
          label: '气瓶净重',
          initialValue: editItem.zl,
          widget: Input,
        },
        {
          key: 'czlMax',
          label: '最大充装量',
          initialValue: editItem.czlMax,
          widget: Input,
        }, {
          key: 'fillingmediumcode',
          label: '填充介质代码',
          initialValue: editItem.fillingmediumcode,
          widget: Input,
        },
        {
          key: 'dwAqf',
          label: '安全阀制造单位',
          initialValue: editItem.dwAqf,
          widget: Select,
          children: this.getHandleAnQuan(),
          widgetProps: {
            onChange: res => this.onChangAnQuan(res),
          },
        },
        {
          key: 'licAqf',
          label: '安全阀制造许可证编号',
          initialValue:
          pro_lnglistModalType === 'create' ? '' : this.state.anquanZzdwBh || editItem.licAqf,
          widget: Input,
        },
        {
          key: 'typeAqf',
          label: '安全阀型号',
          initialValue: editItem.typeAqf,
          widget: Input,
        },
        {
          key: 'dwJzf',
          label: '截止阀制造单位',
          initialValue: editItem.dwJzf,
          widget: Select,
          children: this.getHandleJieZhi(),
          widgetProps: {
            onChange: res => this.onChangJieZhi(res),
          },
        },
        {
          key: 'licJzf',
          label: '截止阀制造许可证编号',
          initialValue:
          pro_lnglistModalType === 'create' ? '' : this.state.jiezhiZZdwBh || editItem.licJzf,
          widget: Input,
        },
        {
          key: 'typeJzf',
          label: '截止阀型号',
          initialValue: editItem.typeJzf,
          widget: Input,
        },

        {
          key: 'dwTyf',
          label: '调压阀制造单位',
          initialValue: editItem.dwTyf,
          widget: Select,
          children: this.getHandleTiaoYa(),
          widgetProps: {
            onChange: res => this.onChangTiaoYa(res),
          },
        },

        {
          key: 'licTyf',
          label: '调压阀制造许可证编号',
          initialValue:
          pro_lnglistModalType === 'create' ? '' : this.state.tiaoyaZzdwBh || editItem.licTyf,
          widget: Input,
        },
        {
          key: 'typeTyf',
          label: '调压阀型号',
          initialValue: editItem.typeTyf,
          widget: Input,
        },

        {
          key: 'dwJjf',
          label: '经济阀制造单位',
          initialValue: editItem.dwJjf,
          widget: Select,
          children: this.getHandleJingJi(),
          widgetProps: {
            onChange: res => this.onChangJingJi(res),
          },
        },
        {
          key: 'licJjf',
          label: '经济阀制造许可证编号',
          initialValue:
          pro_lnglistModalType === 'create' ? '' : this.state.jingjiZzdwBh || editItem.licJjf,
          widget: Input,
        },
        {
          key: 'typeJjf',
          label: '经济阀型号',
          initialValue: editItem.typeJjf,
          widget: Input,
        },
        {
          key: 'twoFxcs',
          label: '返修1次',
          initialValue: editItem.twoFxcs,
          widget: Input,
        },
        {
          key: 'oneFxcs',
          label: '返修2次',
          initialValue: editItem.oneFxcs,
          widget: Input,
        },
        {
          key: 'threeFxcs',
          label: '返修3次',
          initialValue: editItem.threeFxcs,
          widget: Input,
        },
        {
          key: 'pfCs',
          label: '初始电容',
          initialValue: editItem.pfCs,
          widget: Input,
        },
        {
          key: 'zldr',
          label: '增量电容',
          initialValue: editItem.zldr,
          widget: Input,
        },
        {
          key: "type",
          label: "参数维护",
          initialValue: type,
          children: this.gettype(),
          widget: Select,
          required: true,
          widgetProps: {
            onChange: res => this.onchangQuantity(res),
          },
        },
      ],
      onOk: data => {
        // console.log(this.state.jingjiZzdwBh,self.state.jingjiZzdwBh,'.state.jingjiZzdwBh')
        let params = {
          pfCs: data.pfCs,
          threeFxcs: data.threeFxcs,
          oneFxcs: data.oneFxcs,
          twoFxcs: data.twoFxcs,
          typeJjf: data.typeJjf,
          licJjf: this.state.jingjiZzdwBh,
          dwJjf: data.dwJjf,
          typeTyf: data.typeTyf,
          licTyf: this.state.tiaoyaZzdwBh,
          dwTyf: data.dwTyf,
          typeJzf: data.typeJzf,
          licJzf: this.state.jiezhiZZdwBh,
          dwJzf: data.dwJzf,
          typeAqf: data.typeAqf,
          licAqf: this.state.anquanZzdwBh,
          dwAqf: data.dwAqf,
          czlMax: data.czlMax,
          fillingmediumcode: data.fillingmediumcode,
          zl: data.zl,
          syylNd: data.syylNd,
          sjrj: data.sjrj,
          syylGl: data.syylGl,
          typeTs: data.typeTs,
          zjNd: data.zjNd,
          hdSjNft: data.hdSjNft,
          hdSjNd: data.hdSjNd,
          hdMyNd: data.hdMyNd,
          hdNd: data.hdNd,
          gzyl: data.gzyl,
          zldr: data.zldr,
          sjrq: moment(data.sjrq).format('YYYY-MM-DD'),
          pdate: moment(data.pdate).format('YYYY-MM-DD'),
          rj: data.rj,
          batchId: currentPro_lnglist.batchId,
          id: currentPro_lnglist.id,
          ids: this.state.targetKeys ? this.state.targetKeys : []
        };
        // 单瓶
        if (quantity == 1) {
          submitPro_lnglist(params).then(res => {
            this.setState({
              anquanZzdwBh: '',
              jiezhiZZdwBh: '',
              tiaoyaZzdwBh: '',
              jingjiZzdwBh: '',
            });
            pro_lnglistModalChange(false, 'create');
            this.fetchList(pro_lnglistPage);
            // chooseCurrentPro_lnglist(data);
          });
        }
        // 多瓶
        if (quantity == 2) {
          submitProAlllnglist(params).then(res => {
            this.setState({
              anquanZzdwBh: '',
              jiezhiZZdwBh: '',
              tiaoyaZzdwBh: '',
              jingjiZzdwBh: '',
            });
            pro_lnglistModalChange(false, 'create');
            this.fetchList(pro_lnglistPage);
            // chooseCurrentPro_lnglist(data);
          });
        }
        this.selectRow(data)
      },
      onCancel: () => {
        // console.log(quantity)
        this.setState({
          anquanZzdwBh: '',
          jiezhiZZdwBh: '',
          tiaoyaZzdwBh: '',
          jingjiZzdwBh: '',
        });
        pro_lnglistModalChange(false, 'create');
      },
    };
  }

  choosePqpz = () => {
    let { user } = this.props;
    const { frui_qppzById, frui_qppzList } = user;
    return frui_qppzList.map(id => frui_qppzById[id]).map(item => <Option key={item.qpCode}>{item.qpName}</Option>)
  }

  get filterProps() {
    const { actions, product } = this.props;
    const { currentPro_lnglist, pro_lnglistPage } = product;
    const { pro_lnglistModalChange } = actions;
    let self = this
    return {
      title: '',
      searchElements: [
        {
          key: 'noPh',
          widget: Input,
          widgetProps: {
            placeholder: '请输入气瓶批次号或气瓶编号',
          },
        },
        {
          key: 'pid',
          widget: Input,
          widgetProps: {
            placeholder: '气瓶编号',
          },
        },
        {
          key: "qpCode",
          widget: Select,
          widgetProps: {
            style: { width: 200 },
            placeholder: "气瓶品种",
          },
          children: this.choosePqpz()
        }
      ],
      onFilterChange: value => {
        // this.setState({
        //   value
        // }, () => {

        // })
        this.noPh = value.noPh;
        this.pid = value.pid;
        this.qpCode = value.qpCode;
        this.fetchList(1);
      },
      onAdd() {
        pro_lnglistModalChange(true, 'create');
      },
    };
  }

  get buttonProps() {
    const { actions, product } = this.props;
    const { chooseCurrenProductModel, chooseCurrenFaBuModel, remarkModalChange, pro_lnglistModalChange, chooseCurrenDeleteModel, chooseCurrenYjLabel, chooseCurrenProductModelCustom } = actions;
    const { currentPro_lnglist } = product;

    return {
      buttons: [
        {
          name: '一键生成合格证',
          buttonProps: {
            type: 'primary',
            disabled: currentPro_lnglist == null
          },
          onClick: () => {
            chooseCurrenProductModel(true);
          },
        },
        {
          name: '一键生成标签',
          buttonProps: {
            type: 'primary',
            disabled: currentPro_lnglist == null
          },
          onClick: () => {
            chooseCurrenYjLabel(true)
          },
        },
        {
          name: '公示发布',
          buttonProps: {
            type: 'primary',
            disabled: currentPro_lnglist == null
          },
          onClick: () => {
            chooseCurrenFaBuModel(true)
          },
        },
        {
          name: '参数维护',
          buttonProps: {
            type: 'primary',
            disabled: currentPro_lnglist == null
          },

          onClick: () => {
            pro_lnglistModalChange(true, 'updata');
          },
        },
        {
          name: '按批号删除',
          buttonProps: {
            danger: true,
            disabled: currentPro_lnglist == null,
            type: 'primary',
          },
          onClick: () => {
            chooseCurrenDeleteModel(true);
          },
        }
        // , {
        //   name: '修改备注',
        //   buttonProps: {
        //     danger: true,
        //     disabled: currentPro_lnglist == null,
        //     type: 'primary',
        //   },
        //   onClick: () => {
        //     remarkModalChange(true, 'edit');
        //   },
        // }
      ],
    };
  }
  // 删除
  get DeleteModal() {
    const { product, actions } = this.props;
    const { chooseState_delete, deleteProAlllnglistPending, pro_lnglistPage, currentPro_lnglist } = product;
    const { chooseCurrenDeleteModel, deleteProAlllnglist } = actions;
    return {
      visible: chooseState_delete,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: deleteProAlllnglistPending,
      title: '删除',
      centered: true,
      elements: [
        {
          key: 'noPh',
          label: '请输入气瓶批号',
          initialValue: currentPro_lnglist ? currentPro_lnglist.noPh : "",
          widget: Input,
          widgetProps: {
            placeholder: '气瓶批号',
          },
        },
      ],
      onOk: data => {
        let params = {
          noPh: data.noPh,
        };
        deleteProAlllnglist(params).then(res => {
          chooseCurrenDeleteModel(false);
          this.fetchList(pro_lnglistPage);
        })
      },
      onCancel: () => {
        chooseCurrenDeleteModel(false);
      },
    };
  }

  //编辑备注
  get remarkModal() {
    let self = this;
    const { product, actions } = this.props;
    const {
      remarkModalVisible,
      currentPro_lnglist,
      pro_lnglistPage,
      submitPro_lnglistPending,
      quantity,
    } = product;
    const { submitPro_lnglist, chooseCurrentPro_lnglist, remarkModalChange } = actions;
    const editItem = currentPro_lnglist;

    return {
      item: editItem,
      visible: remarkModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitPro_lnglistPending,
      title: '修改备注信息',
      centered: true,
      elements: [
        {
          key: 'remark',
          label: '备注信息',
          initialValue: editItem && editItem.remark ? editItem.remark : '',
          widget: Input,
          widgetProps: {
            placeholder: '备注信息',
          },
        },
      ],
      onOk: data => {
        let params = Object.assign({}, editItem, { remark: data.remark });
        console.log('params', params);
        submitPro_lnglist(params).then(res => {
          remarkModalChange(false, 'create');
          this.fetchList(pro_lnglistPage);
        });

      },
      onCancel: () => {
        remarkModalChange(false);
      },
    }

  }

  // 一键生成标签
  get YjLabelModal() {
    const { product, actions } = this.props;
    const { currentPro_YjLabel, yjlabelActionsPending, currentPro_lnglist, pro_lnglistPage, yjlabelActionsErrormessage, } = product;
    const { chooseCurrenYjLabel, yjlabelActions } = actions;
    let self = this
    return {
      visible: currentPro_YjLabel,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: yjlabelActionsPending,
      title: '标签',
      centered: true,
      elements: [
        {
          key: 'noPh',
          label: '请输入气瓶批号',
          initialValue: currentPro_lnglist ? currentPro_lnglist.noPh : "",
          widget: Input,
          widgetProps: {
            placeholder: '气瓶批号',
          },
        },
      ],
      onOk: data => {
        let params = {
          noPh: data.noPh,
        };
        yjlabelActions(params).then(res => {
          console.log('生成成功了嘛?')
          self.fetchList(pro_lnglistPage)
          console.log(res);
          chooseCurrenYjLabel(false);
          if (res.status === 400) {
          } else {
            message.success('生成完成');
          }
        }).catch((res) => {
          console.log('生成失败了嘛?')
          // console.log(res)
          chooseCurrenYjLabel(false);
          message.error(yjlabelActionsErrormessage || '参数填写不完整，请检查参数');
        })
      },
      onCancel: () => {
        chooseCurrenYjLabel(false);
      },
    };
  }

  // 一键合格证
  get YjHgzModal() {
    const { product, actions } = this.props;
    const { chooseState_show, yJgeneratePassCardActionsPending, currentPro_lnglist, yJgeneratePassCardActionsmessage, pro_lnglistPage } = product;
    const { chooseCurrenProductModel, yJgeneratePassCardActions } = actions;
    let self = this
    return {
      visible: chooseState_show,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: yJgeneratePassCardActionsPending,
      title: '合格证',
      centered: true,
      elements: [
        {
          key: 'noPh',
          label: '请输入气瓶批号',
          initialValue: currentPro_lnglist ? currentPro_lnglist.noPh : "",
          widget: Input,
          widgetProps: {
            placeholder: '气瓶批号',
          },
        },
      ],
      onOk: data => {
        let params = {
          noPh: data.noPh,
        };
        yJgeneratePassCardActions(params).then(res => {
          self.fetchList(pro_lnglistPage)
          // console.log(res);
          chooseCurrenProductModel(false);
          if (res.status === 400) {
          } else {
            message.success('生成完成');
          }
        }).catch((res) => {
          // console.log(res)
          chooseCurrenProductModel(false);
          message.error(yJgeneratePassCardActionsmessage || '参数填写不完整，请检查参数');
        })
      },
      onCancel: () => {
        chooseCurrenProductModel(false);
      },
    };
  }

  // 公示发布
  get FaBuModal() {
    const { product, actions } = this.props;
    const { chooseState_Fabu, gongkaifabuActionsPending, currentPro_lnglist } = product;
    const { chooseCurrenFaBuModel, gongkaifabuActions } = actions;
    return {
      visible: chooseState_Fabu,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: gongkaifabuActionsPending,
      title: '公示发布',
      centered: true,
      elements: [
        {
          key: 'noPh',
          label: '请输入气瓶批号',
          initialValue: currentPro_lnglist ? currentPro_lnglist.noPh : "",
          widget: Input,
          widgetProps: {
            placeholder: '气瓶批号',
          },
        },
      ],
      onOk: data => {
        let params = {
          noPh: data.noPh,
        };
        gongkaifabuActions(params).then(res => {
          // console.log(res);
          chooseCurrenFaBuModel(false);
          if (res.status === 400) {
          } else {
            message.success('生成完成');
          }
        })
      },
      onCancel: () => {
        chooseCurrenFaBuModel(false);
      },
    };
  }
  getMock = () => {
    const targetKeys = [];
    const mockData = [];
    const { pro_lnglistByIdAll, pro_lnglistListAll } = this.props.product
    // console.log(pro_lnglistByIdAll, pro_lnglistListAll)
    let list = pro_lnglistListAll.map(id => pro_lnglistByIdAll[id]).map(item => item)
    console.log('getMock', list);
    for (let i = 0; i < list.length; i++) {
      // console.log(i,list,'i,list')
      const data = {
        key: list[i].id,
        title: list[i].pid,
        description: `description of content${list[i].pid}`,
        // chosen: Math.random() * 2 > 1,
      };
      if (data.chosen) {
        targetKeys.push(data.key);
      }
      mockData.push(data);
    }
    this.setState({ mockData, targetKeys });
  };
  filterOption = (inputValue, option) => option.description.indexOf(inputValue) > -1;
  handleChange = targetKeys => {
    // console.log(targetKeys)
    this.setState({ targetKeys });
  };

  handleSearch = (dir, value) => {
    // console.log('search:', dir, value);
  };
  handleOk = () => {
    let self = this
    // console.log('确认了')
    // console.log(this.state.targetKeys.length)
    if (this.state.targetKeys.length === 0) {
      return message.error('请选择');
    } else {
      self.setState({
        isModalVisible: false
      })
    }
  }
  handleCancel = () => {
    // console.log('取消了')
    this.setState({
      isModalVisible: false,
      targetKeys: []
    })
  }


  // 质量证明
  get modalPropsQuality() {
    const { product, actions } = this.props;
    const { qualityProveCompileAction, qualityProveModalChange } = actions;
    const {
      qualityProveModalvisible,
      qualityProveCompileActionPending,
      pro_lnglistPage,
      currentPro_lnglist
    } = product;
    let editItem = currentPro_lnglist;
    return {
      visible: qualityProveModalvisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: qualityProveCompileActionPending,
      title: '编辑质量证明',
      centered: true,
      elements: [
        {
          key: 'file',
          label: '上传文件',
          initialValue: editItem == undefined ? [] : editItem.file,
          widget: SelectFile,
          widgetProps: {},
        },
        {
          key: 'dateZlzm',
          label: '证书日期',
          initialValue: editItem == undefined ? '' : moment(editItem.dateZlzm),
          widget: DatePicker,
        },
        {
          key: 'datejjZlzm',
          label: '监检日期',
          initialValue: editItem == undefined ? '' : moment(editItem.datejjZlzm),
          widget: DatePicker,
        },
        {
          key: 'jjZlzm',
          label: '监检',
          initialValue: editItem == undefined ? '' : editItem.jjZlzm,
          widget: Input,
        },
        {
          key: 'nameZlzmZd',
          label: '内胆制造单位',
          initialValue: editItem == undefined ? '' : editItem.nameZlzmZd,
          widget: Input,
        },
        {
          key: 'noZlzm',
          label: '质量证书编号',
          initialValue: editItem == undefined ? '' : editItem.noZlzm,
          widget: Input,
        },
        {
          key: 'pzZlzm',
          label: '批准',
          initialValue: editItem == undefined ? '' : editItem.pzZlzm,
          widget: Input,
        },
        {
          key: 'shZlzm',
          label: '审核',
          initialValue: editItem == undefined ? '' : editItem.shZlzm,
          widget: Input,
        }, {
          key: 'ids',
          label: '选择修改编号',
          widget: Select,
          widgetProps: {
            mode: 'tags'
          },
          children: this.getAllProducts()
        }
      ],
      onOk: data => {
        let params = new FormData();
        params.append('file', data.file);
        // params.append('id', qualityProvesId);
        params.append('dateZlzm', data.dateZlzm);
        params.append('datejjZlzm', data.datejjZlzm);
        params.append('jjZlzm', data.jjZlzm);
        params.append('nameZlzmZd', data.nameZlzmZd);
        params.append('noZlzm', data.noZlzm);
        params.append('pzZlzm', data.pzZlzm);
        params.append('shZlzm', data.shZlzm);
        params.append("ids" ,data.ids);

        qualityProveCompileAction(params).then(res => {
          qualityProveModalChange(false);
          this.fetchList(pro_lnglistPage);
        });
      },
      onCancel() {
        qualityProveModalChange(false);
      },
    };
  }


  // 气瓶附件文件
  get modalQpParamsFile() {
    const { product, actions } = this.props;
    const { qpParamsFileUploadingAction, qpParamsFileUploadChoose } = actions;
    const {
      qpParamsFileUploadingId,
      qpParamsFileUploadingActionPending,
      qpParamsFileUploadingVisible,
      currentPlan_lng,
      pro_lnglistPage
    } = product;
    let editItem = currentPlan_lng === undefined ? {} : currentPlan_lng;

    return {
      visible: qpParamsFileUploadingVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: qpParamsFileUploadingActionPending,
      title: '气瓶附件文件',
      centered: true,
      elements: [
        {
          key: 'file',
          label: '上传文件',
          initialValue: editItem === undefined ? [] : editItem.qpParamFile,
          widget: SelectFile,
          widgetProps: {},
        }, {
          key: 'ids',
          label: '选择修改编号',
          widget: Select,
          widgetProps: {
            mode: 'tags'
          },
          children: this.getAllProducts()
        }
      ],
      onOk: data => {
        let params = new FormData();
        params.append('file', data.file);
        params.append("ids", data.ids)
        qpParamsFileUploadingAction(params).then(res => {
          qpParamsFileUploadChoose(false);
          this.fetchList(pro_lnglistPage);
        });
      },
      onCancel() {
        qpParamsFileUploadChoose(false);
      },
    };

  }



  render() {
    // <CrudForm {...this.modalQpDataFile} />
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
        <CrudForm {...this.YjHgzModal} />
        <CrudForm {...this.FaBuModal} />
        <CrudForm {...this.MaintainModal} />
        <CrudForm {...this.DeleteModal} />
        <CrudForm {...this.YjLabelModal} />
        <CrudForm {...this.remarkModal} />
        <Modal title="选择" visible={this.state.isModalVisible} onOk={this.handleOk} onCancel={this.handleCancel} width="50%" className="model">
          <Transfer
            dataSource={this.state.mockData}
            showSearch
            filterOption={this.filterOption}
            targetKeys={this.state.targetKeys}
            onChange={this.handleChange}
            onSearch={this.handleSearch}
            render={item => item.title}
          />
        </Modal>
        <CrudForm {...this.modalMediumSafety} />
        <CrudForm {...this.modalPropsQuality} />
        <CrudForm {...this.modalQpParamsFile} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    product: state.product,
    user: state.user
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    userActions: bindActionCreators({ ...userActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Pro_lnglistPage);



// WEBPACK FOOTER //
// ./src/features/product/Pro_lnglistPage.js